import { useCallback, useEffect, useState } from "react";
import MultiItemSelectDropdown from "../inputs/MultiItemSelectDropdown";
import AppContext from "../context/AppContext";
import TextField from "../inputs/TextField";
import SelectDropdown from "../inputs/SelectDropdown";
import { getHotelsUrl, getTravellers } from "../utils";
import PlaceholderFormInner from "./PlaceholderFormInner";
import FromToDateField from "../inputs/FromToDateField";

export default function EasyOTAFormHotel({ onSubmit, supplierId, supplierSettings }) {
   const [submitData, setSubmitData] = useState({
      rooms: 1,
      nights: 1,
   });
   const [popupsListeners, setPopupsLisners] = useState([]);
   const [locationData, setLocationData] = useState();
   const [travellers, setTravellers] = useState({});
   const travellersItems = getTravellers(supplierSettings);
   const popupCloseEvent = () => {
      popupsListeners.forEach((handler) => {
         handler();
      });
   };

   const registerPops = useCallback((handler) => {
      setPopupsLisners((prev) => {
         return [...prev, handler];
      });
   }, []);

   const handleOnChange = useCallback(({ name, value }) => {
      setSubmitData((prev) => {
         return {
            ...prev,
            [name]: value,
         };
      });
      if (name === "departure_date") {
         setSubmitData((prev) => {
            return {
               ...prev,
               return_date: undefined,
            };
         });
      }
   }, []);

   const handleSubmit = (ev) => {
      ev.preventDefault();
      console.log("Submit", submitData);
      onSubmit && onSubmit({ ...submitData, travellers, locationData });
   };
   const handleOnChangeMult = useCallback((params) => {
      setSubmitData((prev) => {
         return {
            ...prev,
            ...params,
         };
      });
   }, []);

   useEffect(() => {
      if (supplierId) {
         fetch(getHotelsUrl(supplierId))
            .then((res) => res.json())
            .then((json) => {
               // let hotels = [];
               // json.forEach((g) => {
               //    hotels = [...hotels, ...g.hotels.map((h) => ({ ...h, group: g }))];
               // });
               // console.log("Hotels: ", hotels);
               // setLocationData(hotels);

               setLocationData(json);
            });
      }
   }, [supplierId]);

   if (!locationData) return <PlaceholderFormInner />;

   return (
      <AppContext.Provider value={{ registerPopupListener: registerPops, popupCloseEvent }}>
         <div className='form'>
            <form action='#' method='post' id='search-form' onSubmit={handleSubmit} autoComplete='off'>
               <div className='fields'>
                  <FromToDateField
                     params={{
                        from: {
                           field: "departure_date",
                           label: "From",
                        },
                        to: {
                           field: "return_date",
                           label: "To",
                        },
                        noOneway: true,
                     }}
                     minDate={new Date()}
                     required
                     onChange={handleOnChangeMult}
                  />
                  <TextField field='rooms' label='Rooms' min='1' type='number' defaultValue={submitData["rooms"]} />
                  <SelectDropdown
                     field='location'
                     label='Location/Hotel'
                     hint='City or Hotel'
                     options={locationData}
                     onChange={handleOnChange}
                     hideIfSingleOption
                     // className='flex-2'
                     groupChildrenField='hotels'
                  />
                  <MultiItemSelectDropdown
                     field='travellers'
                     label='Travellers'
                     items={travellersItems}
                     data={travellers}
                     settings={supplierSettings}
                     onChange={(selected) => {
                        setTravellers((prev) => {
                           return {
                              ...prev,
                              ...selected,
                           };
                        });
                     }}
                     required
                     validity='You must select atleast 1 adult'
                  />
               </div>
               <button className='btn'>Search</button>
            </form>
         </div>
      </AppContext.Provider>
   );
}
